import React from "react";
import styled, {keyframes} from "styled-components";

const typing = keyframes`
  0% {
    transform: scale(1);
  }
  33% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.4);
  }
  100% {
    transform: scale(1);
  }
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  margin-left: 4px;
  padding-left: 4px;
  width: fit-content;
`;

const Bubble = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 40px;
  border-radius: 12px;
  background-color: #eee;
`;

const Circle = styled.span<{delay: number}>`
  display: block;
  height: 7px;
  width: 7px;
  border-radius: 50%;
  background-color: #8d8d8d;
  margin: 3px;
  animation: ${typing} 1000ms ease-in-out infinite;
  animation-delay: ${props => props.delay}ms;
`;

const TypingIndicator: React.FC = () => {
  return (
    <Container>
      <Bubble>
        <Circle delay={0} />
        <Circle delay={333} />
        <Circle delay={666} />
      </Bubble>
    </Container>
  );
};

export default TypingIndicator;
